export default __webpack_public_path__ + "static/media/deal.e661a408.png";